<template>
  <div class="full">
    <wordcloud
      :data="defaultWords"
      nameKey="name"
      valueKey="value"
      :margin="{top: 15, right: 15, bottom: 15, left: 15 }"
      :wordPadding="3"
      :rotate="{from: -0, to: 0, numOfOrientation: 1 }"
      :spiral="'rectangular'"
      :fontScale="'sqrt'"
    >
    </wordcloud>
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts'
import wordcloud from 'vue-wordcloud'
import nlp from 'compromise'

export default {
  props: {
    roomID: {}
  },
  components: {
    wordcloud
  },
  mounted () {
    API.listSomeLatest({ roomID: this.roomID })
      .then((resp) => {
        this.msgs = resp.data
        let text = this.msgs.reduce((concat, msg) => {
          concat += msg.text + '\n'
          return concat
        }, '')

        let freq = nlp(text).terms().out('freq')
        this.defaultWords = freq.map((obj) => {
          return {
            name: obj.normal,
            value: obj.percent
          }
        })
      })
  },
  data () {
    return {
      msgs: [],
      defaultWords: [
        {
          'name': 'Loading...',
          'value': 1
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
